import axios from "axios";
import React, { useEffect, useState } from "react";

const ServiceWe = () => {
  const [homeWeAre, setHomeWeAre] = useState(null);
  // console.log("why", homeWeAre);
  const fetchHomeWeare = async () => {
    try {
      const response = await axios.get(
        "https://rss.fastwebforge.com/api/pages/home"
      );
      setHomeWeAre(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchHomeWeare();
  }, []);

  //   console.log("Fetched Data:", homeWeAre);
  let heroSection = null;
  if (homeWeAre && homeWeAre.data && homeWeAre.data.sections) {
    heroSection = homeWeAre.data.sections.find(
      (section) => section.title === "home_service"
    );
  }

  // console.log("jj", heroSection);

  return (
    <div className="container services-we-style">
      {/* <p className="Indus-text">
        <span >Industries </span> We Serve
      </p>
      <p>We proudly serve a diverse range of sectors, including:</p> */}

      <div>
        {/* {industries.map((industry, index) => (
          <li key={index} className="text-lg text-gray-700">
            {industry}
          </li>
        ))} */}

        <div
          dangerouslySetInnerHTML={{
            __html:
              heroSection &&
              heroSection.items &&
              heroSection.items[1] &&
              heroSection.items[1].contents &&
              heroSection.items[1].contents.html
                ? heroSection.items[1].contents.html
                : null,
          }}
        />
      </div>
    </div>
  );
};

export default ServiceWe;
